import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// ENUMS
import { Sizes } from '../../enums/sizes';
import { Themes } from '../../enums/themes';
import { Types } from '../../enums/types';

// INTERFACES
import { ITag } from '../../interfaces/Tag.interface';

const notHavingSize = [Types.SPECIAL, Types.ROUNDED, Types.WITHICON];

export const StyledH1 = styled.h1`
  font-family: 'Clan Pro', sans-serif;
  font-weight: ${theme.weights.bold};
`;

export const StyledH2 = styled.h2`
  font-family: 'Clan Pro', sans-serif;
  font-weight: ${theme.weights.regular};
`;

export const Content = styled.div`
  > div {
    margin-right: 8px;
  }
`;

export const Label = styled.div<ITag>`
  ${({ size }) =>
    (size == Sizes.BIG || size == Sizes.SMALL) &&
    css`
      max-width: 20ch;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    `}
`;

export const Container = styled.div<ITag>`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${theme.colors.secondary.gray400};
  box-sizing: border-box;
  border-radius: 41px;
  text-transform: uppercase;
  color: ${theme.colors.secondary.gray100};
  font-family: 'Clan Pro', sans-serif;
  font-weight: ${theme.weights.semibold};
  
  ${({ size }) =>
    size == Sizes.BIG &&
    css`
      font-size: 10px;
      line-height: 24px;
      padding: 0px 11px;
    `}
  ${({ size }) =>
    size == Sizes.SMALL &&
    css`
      font-size: 10px;
      padding: 1px 9.5px;
    `}

  ${({ type }) =>
    type == Types.WITHICON &&
    css`
      color: ${theme.colors.primary.black};
      svg {
        margin-right: 6px;
      }
    `}
  ${({ type }) =>
    !notHavingSize.includes(type) &&
    css`
      &:before {
        content: '';
        width: 6px;
        height: 6px;
        margin-right: 6px;
        background: ${theme.colors.secondary.gray400};
        border-radius: 50%;
      }
    `}
  ${({ type }) =>
    (type == Types.ROUNDED || type == Types.SPECIAL) &&
    css`
      padding: 1.5px 8.2px;
      border-radius: 2px;
      border-color: ${theme.colors.secondary.gray500};
      background: ${theme.colors.secondary.gray500};
      color: ${theme.colors.secondary.gray100};
      font-weight: ${theme.weights.bold};
      font-size: 9px;
      font-weight: bold;
    `}
  ${({ type }) =>
    type == Types.SPECIAL &&
    css`
      text-transform: none;
    `}
  ${({ color }) =>
    color == Themes.PRIMARY &&
    css`
      color: ${theme.colors.secondary.blue100};
      border-color: ${theme.colors.secondary.blue500};
      &:before {
        background: ${theme.colors.secondary.blue400};
      }
    `}
  ${({ color }) =>
    color == Themes.SECONDARY &&
    css`
      color: ${theme.colors.secondary.green100};
      border-color: ${theme.colors.secondary.green500};
      &:before {
        background: ${theme.colors.secondary.green400};
      }
    `}

  ${({ color }) =>
    color == Themes.WARNING &&
    css`
      color: ${theme.colors.secondary.orange100};
      border-color: ${theme.colors.secondary.orange500};
      &:before {
        background: ${theme.colors.secondary.orange400};
      }
    `}

  ${({ color }) =>
    color == Themes.INFO &&
    css`
      color: ${theme.colors.secondary.lilac100};
      border-color: ${theme.colors.secondary.lilac500};
      &:before {
        background: ${theme.colors.secondary.lilac400};
      }
    `}
  ${({ color }) =>
    color == Themes.ALERT &&
    css`
      color: ${theme.colors.secondary.red100};
      border-color: ${theme.colors.secondary.red500};
      &:before {
        background: ${theme.colors.secondary.red400};
      }
    `}
`;
